import { useState, useEffect } from 'react';

// Shared data that all components can access
const LOCAL_STORAGE_KEY = 'enableMemoUpload';
const getInitialValue = () => {
  const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
  if (stored === 'true') return true;
  if (stored === 'false') return false;
  return false;
};

const sharedData = {
  enableMemoUpload: getInitialValue(),
};

// List of components that want to know when data changes
const subscribers: Array<() => void> = [];

// Hook to share memo upload setting between components
export const useSettlementConfig = () => {
  const [data, setData] = useState(sharedData);

  // When component mounts, subscribe to changes
  useEffect(() => {
    const handleUpdate = () => {
      setData({ ...sharedData }); // Update this component
    };

    subscribers.push(handleUpdate);

    // Clean up when component unmounts
    return () => {
      const index = subscribers.indexOf(handleUpdate);
      if (index > -1) {
        subscribers.splice(index, 1);
      }
    };
  }, []);


  // Update shared data, localStorage, and tell all components
  const updateMemoUpload = (canUpload: boolean) => {
    sharedData.enableMemoUpload = canUpload;
    localStorage.setItem(LOCAL_STORAGE_KEY, String(canUpload));
    // Tell all subscribed components to update
    subscribers.forEach(notify => notify());
  };

  return {
    enableMemoUpload: data.enableMemoUpload, 
    setEnableMemoUpload: updateMemoUpload,
  };
};